/* eslint-disable */
import Page from '@/views/Page'
import { strapi } from '@/api'

export default async function getRoutes(locale = 'all') {
  const pagesInfo = await strapi.getPagesInfo(locale)
	
  const routes = pagesInfo.map((r) => ({
    ...r,
    path: r.route,
    component: Page
  }))

	const defaultRoutes = [
    {
		  path: '/',
	  	redirect: '/en'
  	},
    {
		  path: '/crc',
	  	redirect: '/en/crc'
  	}
  ]

  return [...defaultRoutes, ...routes]
}
